import { ComponentProps } from 'react';
import { useField } from 'formik';
import QuillDelta from 'quill-delta';
import { QuillInput } from './QuillInput';

export function QuillField({
	name,
	...props
}: Omit<ComponentProps<typeof QuillInput>, 'onChange' | 'value'> & {
	name: string;
}) {
	const [, { value }, { setValue }] = useField<QuillDelta>(name);

	return (
		<QuillInput {...props} value={value || { ops: [] }} onChange={(value) => setValue(value)} />
	);
}
